/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} File_Upload_Invalid_ExtensionInputs */

const en_file_upload_invalid_extension = /** @type {(inputs: File_Upload_Invalid_ExtensionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File "${i?.fileName}" has an unsupported extension. Only .xml files or files without an extension are allowed.`)
};

const nl_file_upload_invalid_extension = /** @type {(inputs: File_Upload_Invalid_ExtensionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bestand "${i?.fileName}" heeft een niet-ondersteunde extensie. Alleen .xml-bestanden of bestanden zonder extensie zijn toegestaan.`)
};

/**
* | output |
* | --- |
* | "File \"{fileName}\" has an unsupported extension. Only .xml files or files without an extension are allowed." |
*
* @param {File_Upload_Invalid_ExtensionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const file_upload_invalid_extension = /** @type {((inputs: File_Upload_Invalid_ExtensionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Invalid_ExtensionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_file_upload_invalid_extension(inputs)
	return en_file_upload_invalid_extension(inputs)
});